import React from 'react';

export const Cog = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
    <path
      d="M7.57873 8.99998C7.57873 9.64225 7.83387 10.2582 8.28802 10.7124C8.74217 11.1665 9.35814 11.4217 10.0004 11.4217C10.6427 11.4217 11.2586 11.1665 11.7128 10.7124C12.1669 10.2582 12.4221 9.64225 12.4221 8.99998C12.4221 8.35771 12.1669 7.74175 11.7128 7.2876C11.2586 6.83345 10.6427 6.57831 10.0004 6.57831C9.35814 6.57831 8.74217 6.83345 8.28802 7.2876C7.83387 7.74175 7.57873 8.35771 7.57873 8.99998Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12.0185 0.927734H7.98234V2.86346C7.13736 3.14159 6.35903 3.59149 5.69628 4.18489L4.01806 3.21622L2 6.7115L3.67741 7.68017C3.49646 8.55074 3.49646 9.44922 3.67741 10.3198L2 11.2885L4.01806 14.7837L5.69709 13.8151C6.35938 14.4083 7.13713 14.8582 7.98153 15.1365V17.0722H12.0177V15.1365C12.8626 14.8584 13.641 14.4085 14.3037 13.8151L15.9819 14.7837L18 11.2885L16.3226 10.3198C16.5036 9.44923 16.5036 8.55074 16.3226 7.68017L18 6.7115L15.9819 3.21622L14.3029 4.18489C13.6406 3.59168 12.8629 3.14179 12.0185 2.86346V0.927734Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
